import React from 'react'
import { func } from 'prop-types'

import { Row, Col, Tabs, TabPanel } from '@paypalcorp/pp-react'
import { fptiCustomClick, serverData } from '../../utils'
import { DWSections } from '../../components'
import {
  secondaryHeader,
  dataPlatformSections,
  privacySections,
} from '../../config'

const PRIVACY_LINK_INDEX = 2

const DWSubHeader = ({ onSectionClick }) => {
  const handleHeaderLinksClick = (event, tabIdxClicked) => {
    fptiCustomClick(secondaryHeader[tabIdxClicked].fptiClickData)
    window.location.href = secondaryHeader[tabIdxClicked].link
  }

  const renderTabPanels = () =>
    secondaryHeader.map(({ id, panelId, containerClass }) => (
      <TabPanel id={panelId} key={id} className={containerClass}>
        {id === 'privacyLink' && (
          <div id="dw-privacy-link">
            <DWSections
              sections={privacySections}
              onSectionClick={onSectionClick}
            />
            <DWSections
              sections={dataPlatformSections}
              onSectionClick={onSectionClick}
            />
          </div>
        )}
      </TabPanel>
    ))

  return (
    <Row className="one-section-only">
      <Col md={{ span: 12 }}>
        {serverData.isNative ? (
          <div id="dw-privacy-link">
            <DWSections
              sections={privacySections}
              onSectionClick={onSectionClick}
            />
            <DWSections
              sections={dataPlatformSections}
              onSectionClick={onSectionClick}
            />
          </div>
        ) : (
          <Tabs
            theme="v1"
            name="SecondaryHeaderLinks"
            selectedTabIdx={PRIVACY_LINK_INDEX}
            tabs={secondaryHeader}
            onClick={handleHeaderLinksClick}
            tabClassName="subHeader-tab"
          >
            {renderTabPanels()}
          </Tabs>
        )}
      </Col>
    </Row>
  )
}

DWSubHeader.propTypes = {
  onSectionClick: func.isRequired,
}

export default DWSubHeader
